import {createStore, combineReducers} from 'redux'
import accountReducer from "../redux/actions/account"
import configReducer from "../redux/actions/config"
import footerReducer from "../redux/actions/footer"

const initialState = {
	sidebarShow: true
}

const changeState = (state = initialState, {type, ...rest}) => {
	switch (type) {
		case 'set':
			return {...state, ...rest}
		default:
			return state
	}
}

const rootReducer = combineReducers({
	state: changeState,
	account: accountReducer,
	config: configReducer,
	footer: footerReducer
})

export const store = createStore(rootReducer)
export default store
